import React from 'react';

import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

export const SecLendingEnrollmentInviteTerms: React.FC = () => {
  return (
    <ul className={css({ paddingLeft: 'space.300', display: 'grid', gap: 'space.100', my: 'space.0' })}>
      <li>
        By opting into, you acknowledge to the{' '}
        <SambaAutoLink
          variant="textSecondary"
          to="https://betterment-prod-cdn.s3.us-east-1.amazonaws.com/agreements/Fully+Paid+Lending+-+MSLA+-+Risk+Disclosure+-+Trust+Agreement+(Final+11.04.25).pdf"
          target="_blank"
        >
          Apex Master Securities Lending Agreement
        </SambaAutoLink>{' '}
        and that you have read the{' '}
        <SambaAutoLink
          variant="textSecondary"
          to="https://www.betterment.com/legal/sec-lending-disclosures"
          target="_blank"
        >
          Important Disclosures
        </SambaAutoLink>
        . You'll be automatically enrolled once securities lending becomes available.
      </li>
      <li>
        You understand that Apex is the sole borrower of securities under the Fully-Paid Securities Lending (“FPSL”)
        Program and may lend out your securities.
      </li>
      <li>
        You understand loaned securities are not covered by SIPC, but are backed by at least 100% cash collateral held
        at a third-party bank.
      </li>
      <li>
        To learn more, please review our{' '}
        <SambaAutoLink
          variant="textSecondary"
          to="https://www.betterment.com/help/tag/securities-lending-faqs"
          target="_blank"
        >
          FAQs
        </SambaAutoLink>{' '}
        or reach out to Support.
      </li>
    </ul>
  );
};
